import { IonIcon } from "@ionic/react";
import axios from "axios";
import { logoWhatsapp } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import ModalPacienteForm from "../../components/formComponents/ModalFormPaciente/ModalFormPaciente";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import ModalCambioContrasena from "../../components/formComponents/ModalCambioContrasena/ModalCambioContrasena";
import ModalActualizarContrasena from "../../components/formComponents/ModalActualizarContrasena/ModalActualizarContrasena";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Link,
  Typography,
} from "@mui/joy";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";
import "./Login.css";

const LoginIonic = () => {
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });

  // Estados para modales y lógica de cambio de contraseña
  const [showModal, setShowModal] = useState(false);
  const [showModalActualizar, setShowModalActualizar] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);

  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const handleOpenModal = () => {
    setAttemptCount(0);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const handlePasswordChange = async () => {
    try {
      // Normalizar email y documento para evitar problemas de espacios o mayúsculas
      const cleanEmail = (usuario.email || "").trim().toLowerCase();
      const cleanDocumento = (usuario.usuario || "").trim();
      const response = await axios.post(
        `${urlAxioPP}/Usuarios/OlvideMiContrasenia`.replace(/([^:]\/){1,}\/+/g, "$1"),
        {
          Documento: cleanDocumento,
          URL: "https://pacientes.fecundart.com.ar/RecoveryPass/####",
          //URL: "http://fecundart.ddns.net:3000/RecoveryPass/####",

          Mail: cleanEmail,
        }
      );

      if (response.status === 200) {
        alert("Solicitud de cambio de contraseña enviada. Revisa tu email.");
        setShowModal(false);
        setAttemptCount(0);
      }
    } catch (error) {
      if (attemptCount < 2) {
        alert(
          "Para una doble verificación, por favor confirme su correo ingresado, si es correcto, haga click en 'Enviar Solicitud'."
        );
        setAttemptCount(attemptCount + 1);
      } else {
        alert(
          "El mail ingresado es incorrecto. Debe comunicarse telefónicamente con Instituto Fecundart al 3512297252 para actualizarlo. Caso contrario, NO podrá recuperar su contraseña."
        );
        setShowModal(false);
        setAttemptCount(0);
        history.push("/Login");
      }
    }
  };

  const history = useHistory();
  useTituloPagina();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));
    setTituloPagina(localStorage.getItem("nombreClinica"));

    document.title = localStorage.getItem("tituloWeb");
    sessionStorage.removeItem("ppUL");
  }, []);

  const loginPaciente = async (usuario, password) => {
    // Normalizar inputs para evitar errores por espacios, mayúsculas, etc.
    const cleanUsuario = (usuario || "").replace(/\s+/g, '').trim();
    const cleanPassword = (password || "").replace(/\s+/g, '').trim();
    console.log('Login - usuario:', cleanUsuario, '| password:', cleanPassword);
    try {
      const response = await axios.post(`${urlAxioPP}Usuarios/LoginPaciente`, {
        nombreUsuario: cleanUsuario,
        password: cleanPassword,
      });
      return response.data.token;
    } catch (error) {
      setErrorPassword(true);
      setMsjErrorPassword("Documento o contraseña incorrecto");
      mostrarNotificacion(
        true,
        "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.",
        "rojo"
      );
      throw error;
    }
  };

  const obtenerPaciente = async (token, documento) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(
        `${urlAxioPP}Pacientes?documento=${documento}`,
        config
      );
      const data = response.data[0];
      return {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };
    } catch (error) {
      console.error("Error en petición obtenerPaciente", error.response);
      mostrarNotificacion(
        true,
        "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.",
        "rojo"
      );
      throw error;
    }
  };

  const handleClickLogin = async () => {
    setCargando(true);
    try {
      if (usuario.usuario !== "" && usuario.password !== "") {
        const token = await loginPaciente(usuario.usuario, usuario.password);
        const paciente = await obtenerPaciente(token, usuario.usuario);
        if (paciente) {
          mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
          setUsuario(paciente);
          sessionStorage.setItem("ppUL", JSON.stringify(paciente));
          history.push("/portal/Inicio", { justLogin: true });
        }
      } else {
        if (usuario.usuario === "") setErrorUsuario(true);
        if (usuario.password === "") {
          setErrorPassword(true);
          setMsjErrorPassword("Debe ingresar su contraseña");
        }
      }
    } catch (error) {
      console.error("Error en el proceso de inicio de sesión", error);
    } finally {
      setCargando(false);
    }
  };

  const handleChangeUsuario = (e) => {
    let value = e.target.value;
    // Eliminar espacios, caracteres invisibles y dejar solo números
    value = value.replace(/\s+/g, '').replace(/[^0-9]+/g, '');
    setErrorUsuario(false);
    setUsuario((prev) => ({ ...prev, usuario: value }));
  };

  // Permitir cualquier valor en contraseña (alfanumérico)
  const handleChangePassword = (e) => {
    let value = e.target.value;
    // Eliminar espacios y caracteres invisibles
    value = value.replace(/\s+/g, '');
    setErrorPassword(false);
    setUsuario((prev) => ({ ...prev, password: value }));
  };
  // Handler principal de login con verificación documento=contraseña
  const handleClickSubmit = () => {
    setCargando(true);
    if (usuario.usuario === usuario.password) {
      if (attemptCount < 1) {
        alert(
          "La contraseña no debe ser igual al documento. Ingrese la contraseña correcta. En caso de no contar con contraseña, ingrese nuevamente su nro. de documento y será dirigido al cambio de contraseña."
        );
        setAttemptCount(attemptCount + 1);
        setCargando(false);
        return;
      } else {
        alert(
          "La contraseña no debe ser igual al documento. Proceder a cambiar la contraseña."
        );
        setShowModal(true);
        setCargando(false);
        return;
      }
    }
    handleClickLogin();
    setCargando(false);
    setAttemptCount(0);
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "No definido";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el numero de telefono a su portapapeles",
      ""
    );
  };

  return (
    <div className="login">
      <Container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        style={{
          height: "100vh",
          backgroundImage: "assets/imagendefondoLogin.webp",
        }}
      >
        <Row item="true"></Row>
        <Row item="true">
          <Card className="login-card" style={{ width: "350px" }}>
            <CardContent>
              <Row container spacing={2} rowGap={2}>
                <Column xs={12}>
                  <Box display="flex" justifyContent="center" mb={2}>
                    <img
                      alt="Logo clinica"
                      src="assets/logo-largo.png"
                      height={"50%"}
                      loading="lazy"
                    />
                  </Box>
                  <Typography level="title-lg" align="center">
                    {"Portal del paciente".toUpperCase()}
                  </Typography>
                  <form
                    noValidate
                    autoComplete="off"
                    style={{ marginBottom: "7.5px" }}
                  >
                    <CustomInput
                      fullWidth
                      margin="normal"
                      value={usuario.usuario}
                      onChange={handleChangeUsuario}
                      error={errorUsuario}
                      startDecorator={
                        <Typography
                          variant="plain"
                          color="neutral"
                          sx={{ width: "100px" }}
                        >
                          Documento:
                        </Typography>
                      }
                    />
                    <hr />
                    <CustomInput
                      fullWidth
                      margin="normal"
                      startDecorator={
                        <Typography
                          variant="plain"
                          color="neutral"
                          sx={{ width: "100px" }}
                        >
                          Contraseña:
                        </Typography>
                      }
                      endDecorator={
                        <React.Fragment>
                          <Divider orientation="vertical" />
                          <Button
                            onClick={handleChangeVisibilityOfPassword}
                            type="button"
                            variant="plain"
                            color="neutral"
                          >
                            {blnVerPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </Button>
                        </React.Fragment>
                      }
                      type={blnVerPassword ? "text" : "password"}
                      value={usuario.password}
                      onChange={handleChangePassword}
                      error={errorPassword}
                      helperText={
                        <span>
                          Si no cambió su contraseña, ingrese su número de documento.{' '}
                          <span
                            style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                            onClick={handleOpenModal}
                          >
                            ¿Olvidó su contraseña?
                          </span>
                        </span>
                      }
                      errorHelperText={msjErrorPassword}
                    />
                    <CustomInput
                      fullWidth
                      variant="solid"
                      color="primary"
                      type="button"
                      onClick={handleClickSubmit}
                      disabled={cargando}
                      value={"Ingresar"}
                    />
                  </form>

                  <Typography level="body-xs" paddingInline={1}>
                    {
                      "Si es la primera vez que te vas a atender con nosotros, debes registrarte mediante nuestro WhatsApp."
                    }
                  </Typography>

                  <StyledButton
                    className="verde"
                    expand="block"
                    fill="clear"
                    onClick={handleClickCopiarTelefono}
                    href={
                      "https://api.whatsapp.com/send?phone=+5493512297252&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                    }
                    target="_blank"
                  >
                    <IonIcon icon={logoWhatsapp} />
                  </StyledButton>
                </Column>
              </Row>
            </CardContent>
          </Card>
        </Row>
        <Row item="true">
          <Link
            href="https://www.gacitua.com.ar/"
            rel="Proveedor del servicio noreferrer"
            target="_blank"
          >
            <Typography level="title-lg">
              <Typography color="neutral"> {"Powered by "}</Typography>
              <img
                src={"assets/logoGacitua.png"}
                alt="logo gacitua y asociados"
                width={17}
                height={17}
                loading="lazy"
              />
              <Typography> {" Gacitua y asociados"}</Typography>
            </Typography>
          </Link>
        </Row>

        <ModalPacienteForm
          mostrarNotificacion={mostrarNotificacion}
          openModal={registrarPaciente}
          setOpenModal={setRegistrarPaciente}
        />

        <CustomToast
          openToast={toast.open}
          onDidDismiss={() => mostrarNotificacion(false, "", "")}
          message={toast.mensaje}
          colorNotificacion={toast.tipo}
        />
  {cargando && !showModalActualizar && !showModal && <LoadingBackdrop visualizar={cargando} />}

        <ModalCambioContrasena
          isOpen={showModal}
          usuario={usuario}
          setUsuario={setUsuario}
          handlePasswordChange={handlePasswordChange}
          onClose={handleCloseModal}
        />
        <ModalActualizarContrasena
          open={showModalActualizar}
          onClose={() => setShowModalActualizar(false)}
        />
      </Container>
    </div>
  );
};

export default LoginIonic;





